<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h3>فاکتورهای من</h3>
      </template>
      <template slot="content">
        <Factor-Manager></Factor-Manager>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import FactorManager from '../../Contracts/FactorManager.vue'
export default {
  data() {
    return {}
  },
  components: { Card, FactorManager },
}
</script>
